interface AccessTokenClient {
  AccessToken: Promise<string> | undefined
}

export const setAccessTokenProvider = (
  client: AccessTokenClient,
  getAccessToken: () => Promise<string>,
): void => {
  Object.defineProperty(client, 'AccessToken', {
    configurable: true,
    get: () => getAccessToken(),
  })
}
